const indexpageText = {
  allProducts: "Hepsi",
  itemCard: {
    color: "Renk: ",
  },
};

export default indexpageText;
